export enum ClientRequestStatusEnum {
  WAITING_FOR_ADDITIONAL_DOCUMENTS = "WAITING_FOR_ADDITIONAL_DOCUMENTS",
  WAITING_FOR_SIGNATURE = "WAITING_FOR_SIGNATURE",
  WAITING_FOR_TRANSFER = "WAITING_FOR_TRANSFER",
  FUNDS_TO_INVEST = "FUNDS_TO_INVEST",
  FUNDS_INVESTED = "FUNDS_INVESTED",
  WAITING_WITHDRAWAL = "WAITING_WITHDRAWAL",
  WAITING_FOR_TRANSFER_WITHDRAWAL = "WAITING_FOR_TRANSFER_WITHDRAWAL",
  MONEY_SENT = "MONEY_SENT"
}

export const additionalInvestClientRequestStatusList: ClientRequestStatusEnum[] = [
  ClientRequestStatusEnum.WAITING_FOR_ADDITIONAL_DOCUMENTS,
  ClientRequestStatusEnum.WAITING_FOR_SIGNATURE,
  ClientRequestStatusEnum.WAITING_FOR_TRANSFER,
  ClientRequestStatusEnum.FUNDS_TO_INVEST,
  ClientRequestStatusEnum.FUNDS_INVESTED
];

export const withdrawalClientRequestStatusList: ClientRequestStatusEnum[] = [
  ClientRequestStatusEnum.WAITING_FOR_ADDITIONAL_DOCUMENTS,
  ClientRequestStatusEnum.WAITING_FOR_SIGNATURE,
  ClientRequestStatusEnum.WAITING_FOR_TRANSFER_WITHDRAWAL,
  ClientRequestStatusEnum.MONEY_SENT,
];